function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import styled from 'styled-components';
import { background, border } from 'styled-system';
import ssPropTypes from '@styled-system/prop-types';
import { themed, cardStyle, clickableStyle } from '../utils/system';
import { Box } from '../index';
var Card = styled(Box)(themed('Card'), background, border, cardStyle, clickableStyle);
Card.propType = _extends({}, ssPropTypes.background, ssPropTypes.border);
Card.displayName = 'Card';
export default Card;